(function () {
  'use strict';

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function init(root) {
    if (!root || root.dataset.socialStoriesReady === 'true') return;

    var dialog = root.querySelector('[data-social-story-dialog]');
    var viewer = root.querySelector('[data-social-story-viewer]');
    var progress = root.querySelector('[data-social-story-progress]');
    var previous = root.querySelector('[data-social-story-prev]');
    var next = root.querySelector('[data-social-story-next]');
    var openers = toArray(root.querySelectorAll('[data-social-story-open]'));
    var closers = toArray(root.querySelectorAll('[data-social-story-close]'));
    var slides = toArray(root.querySelectorAll('[data-social-story-slide]'));

    if (!dialog || !viewer || !progress || !previous || !next || !slides.length) return;

    root.dataset.socialStoriesReady = 'true';

    var current = 0;
    var lastFocus = null;
    var tornDown = false;
    var openerHandlers = [];
    var segments = slides.map(function () {
      var segment = document.createElement('span');
      segment.className = 'veji-social-stories__progress-segment';
      progress.appendChild(segment);
      return segment;
    });

    function getSocialVideoSource(slide) {
      var platform = slide && slide.dataset.socialVideoPlatform;
      var videoId = slide && slide.dataset.socialVideoId;
      if (!videoId) return null;
      if (platform === 'tiktok') {
        return 'https://www.tiktok.com/player/v1/' + encodeURIComponent(videoId) + '?autoplay=1&controls=1&closed_caption=1&description=0&music_info=0&rel=0';
      }
      if (platform === 'instagram') {
        return 'https://www.instagram.com/reel/' + encodeURIComponent(videoId) + '/embed/';
      }
      return null;
    }

    function destroySocialVideoPlayers() {
      slides.forEach(function (slide) {
        var target = slide.querySelector && slide.querySelector('[data-social-video-player-target]');
        if (!target) return;
        target.replaceChildren();
        target.classList.remove('is-loaded');
      });
    }

    function mountSocialVideoPlayer(slide) {
      var source = getSocialVideoSource(slide);
      if (!source) return;
      var platform = slide.dataset.socialVideoPlatform;
      var target = slide.querySelector('[data-social-video-player-target]');
      if (!target || target.children.length) return;
      var iframe = document.createElement('iframe');
      iframe.src = source;
      iframe.title = (platform === 'instagram' ? 'Reel Instagram de ' : 'Vidéo TikTok de ') +
        (slide.dataset.socialVideoHandle || 'la communauté VEJI');
      iframe.allow = platform === 'instagram'
        ? 'autoplay; encrypted-media; picture-in-picture; fullscreen'
        : 'autoplay; fullscreen';
      iframe.allowFullscreen = true;
      iframe.loading = 'eager';
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      iframe.addEventListener('load', function () {
        if (target.contains(iframe)) target.classList.add('is-loaded');
      }, { once: true });
      target.appendChild(iframe);
    }

    function show(index) {
      destroySocialVideoPlayers();
      current = Math.max(0, Math.min(slides.length - 1, Number(index) || 0));

      slides.forEach(function (slide, slideIndex) {
        slide.hidden = slideIndex !== current;
      });

      segments.forEach(function (segment, segmentIndex) {
        segment.classList.toggle('is-complete', segmentIndex < current);
        segment.classList.toggle('is-current', segmentIndex === current);
      });

      previous.disabled = current === 0;
      next.disabled = current === slides.length - 1;

      if (dialog.hidden === false) mountSocialVideoPlayer(slides[current]);
    }

    function open(index, trigger) {
      lastFocus = trigger || document.activeElement;
      dialog.hidden = false;
      document.body.classList.add('veji-social-stories-lock');
      show(index);
      requestAnimationFrame(function () {
        if (!dialog.hidden && root.isConnected) viewer.focus();
      });
    }

    function close() {
      if (dialog.hidden) return;
      destroySocialVideoPlayers();
      dialog.hidden = true;
      document.body.classList.remove('veji-social-stories-lock');
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    function handlePrevious() {
      if (current > 0) show(current - 1);
    }

    function handleNext() {
      if (current < slides.length - 1) show(current + 1);
    }

    function getFocusableElements() {
      return toArray(viewer.querySelectorAll(
        'a[href], button:not([disabled]), iframe, [tabindex]:not([tabindex="-1"])'
      )).filter(function (element) {
        return !element.disabled &&
          !element.hidden &&
          !(element.closest && element.closest('[hidden]'));
      });
    }

    function handleKeydown(event) {
      if (dialog.hidden) return;

      if (event.key === 'Tab') {
        var focusableElements = getFocusableElements();
        if (!focusableElements.length) {
          event.preventDefault();
          viewer.focus();
          return;
        }

        var firstFocusable = focusableElements[0];
        var lastFocusable = focusableElements[focusableElements.length - 1];
        var activeElement = document.activeElement;
        var focusIsOutside = activeElement !== viewer && !viewer.contains(activeElement);

        if (event.shiftKey &&
            (activeElement === viewer || activeElement === firstFocusable || focusIsOutside)) {
          event.preventDefault();
          lastFocusable.focus();
        } else if (!event.shiftKey &&
                   (activeElement === viewer || activeElement === lastFocusable || focusIsOutside)) {
          event.preventDefault();
          firstFocusable.focus();
        }
      } else if (event.key === 'Escape') {
        event.preventDefault();
        close();
      } else if (event.key === 'ArrowLeft' && current > 0) {
        event.preventDefault();
        show(current - 1);
      } else if (event.key === 'ArrowRight' && current < slides.length - 1) {
        event.preventDefault();
        show(current + 1);
      }
    }

    function handleSectionUnload(event) {
      if (event.target === root || (event.target && event.target.contains && event.target.contains(root))) teardown();
    }

    function teardown() {
      if (tornDown) return;
      tornDown = true;
      document.removeEventListener('keydown', handleKeydown);
      document.removeEventListener('shopify:section:unload', handleSectionUnload);
      openerHandlers.forEach(function (binding) {
        binding.opener.removeEventListener('click', binding.handler);
      });
      closers.forEach(function (closer) {
        closer.removeEventListener('click', close);
      });
      previous.removeEventListener('click', handlePrevious);
      next.removeEventListener('click', handleNext);
      destroySocialVideoPlayers();
      dialog.hidden = true;
      document.body.classList.remove('veji-social-stories-lock');
      progress.replaceChildren();
      segments = [];
      delete root.dataset.socialStoriesReady;
    }

    openers.forEach(function (opener) {
      var handler = function () {
        open(opener.dataset.socialStoryOpen, opener);
      };
      openerHandlers.push({ opener: opener, handler: handler });
      opener.addEventListener('click', handler);
    });

    closers.forEach(function (closer) {
      closer.addEventListener('click', close);
    });

    previous.addEventListener('click', handlePrevious);
    next.addEventListener('click', handleNext);
    document.addEventListener('keydown', handleKeydown);
    document.addEventListener('shopify:section:unload', handleSectionUnload);

    show(0);
  }

  function boot(scope) {
    var roots = [];

    if (scope && scope.matches && scope.matches('[data-social-stories]')) {
      roots.push(scope);
    }
    if (scope && scope.querySelectorAll) {
      roots = roots.concat(toArray(scope.querySelectorAll('[data-social-stories]')));
    }

    roots.forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
